import axiosInstance from '../common/axios';
const backendUrl = process.env.REACT_APP_BACKEND_URL;

// Save Supplier Info
export async function saveSupplierInfo(data) {
  return axiosInstance.post(`${backendUrl}/api/suppliers`, data);
}


// Save Supplier Info
export async function updateSupplierInfo(supplierId, data) {
  return axiosInstance.put(`${backendUrl}/api/suppliers/${supplierId}`, data);
}

// Fetch Company Types
export async function getCompanyTypes() {
  return axiosInstance.get(`${backendUrl}/api/company-types`);
}


// Call to fetch supplier info 
export async function getSupplierInfo(email) {
  return axiosInstance.get(`${backendUrl}/api/suppliers/by-email`, {
        params: {
          email: email,
        },
      }); // or whatever your API is
}


export async function checkSupplierNameExists({ name, email, phone }) {
  try {
    const response = await axiosInstance.get(`${backendUrl}/api/suppliers/check-duplicates`, {
      params: { name, email, phone },
    });
    
    // Status 204 received: No duplicates found.
    return { isConflict: false, field: null, message: null }; 

  } catch (error) {
    // Check for the expected 409 Conflict error
    if (error.response && error.response.status === 409) {
      const errorData = error.response.data; // This will be the SupplierValidationError object
      
      // Return the specific conflict details
      return { 
        isConflict: true, 
        field: errorData.field,     // e.g., "name", "email", or "phone"
        message: errorData.message  // e.g., "The supplier name '...' is already registered."
      };
    }
    
    // Handle all other errors (network, 500 server error, etc.)
    console.error('Unexpected check error:', error);
    return { isConflict: false, field: 'network', message: 'An unknown error occurred.' };
  }
}



export async function  fetchSuppliers(){
  return await axiosInstance.get("/api/suppliers");
}

export async function requestProductApproval(supplierId,data) {

  if(supplierId){
    return await axiosInstance.post(`${backendUrl}/api/products/requestapproval/suppliers/${supplierId}`, data);
  }else{
    return await axiosInstance.post(`${backendUrl}/api/products/requestapproval/suppliers`, data);
  }
  
}


export async function approveProduct(data) {
  return await axiosInstance.post(`${backendUrl}/api/products/approve`, data);
}

